import { throttle } from 'throttle-debounce';

const $ = window.jQuery;

const $wnd = $(window);
const $doc = $(document);
const $body = $('body');
const $html = $('html');

/**
 * Debounce resize
 */
const resizeArr = [];
function debounceResized() {
  if (resizeArr.length) {
    for (let k = 0; k < resizeArr.length; k += 1) {
      resizeArr[k]();
    }
  }
}
$wnd.on(
  'ready load resize orientationchange',
  throttle(200, () => {
    debounceResized();
  })
);
debounceResized();

function debounceResize(func) {
  if ('function' === typeof func) {
    resizeArr.push(func);
  } else {
    window.dispatchEvent(new Event('resize'));
  }
}

export { $, $wnd, $doc, $html, $body, debounceResize };
